export default __webpack_public_path__ + "static/media/fondoAsambleaHorizontal.749c5639.webp";